import _implicitStylesheets from "./icon.css";
import _implicitScopedStylesheets from "./icon.scoped.css?scoped=true";
import {freezeTemplate, parseFragment, registerTemplate, sanitizeAttribute} from "lwc";
const $fragment1 = parseFragment`<svg${"c0"} role="img"${"a0:aria-label"}${"a0:aria-hidden"}${2}><use${"a1:xlink:href"}${3}/><title${"a2:id"}${3}>${"t3"}</title></svg>`;
const stc0 = {
  lwc: {
    dom: "manual"
  }
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {ncls: api_normalize_class_name, fid: api_scoped_frag_id, gid: api_scoped_id, d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, h: api_element} = $api;
  return [$cmp.externalIconSet ? api_static_fragment($fragment1, 1, [api_static_part(0, {
    className: api_normalize_class_name($cmp.classes),
    attrs: {
      "aria-label": $cmp.iconDescription,
      "aria-hidden": $cmp.ariaHidden
    }
  }, null), api_static_part(1, {
    attrs: {
      "xlink:href": sanitizeAttribute("use", "http://www.w3.org/2000/svg", "xlink:href", api_scoped_frag_id($cmp.getExternalIconURL))
    }
  }, null), api_static_part(2, {
    attrs: {
      "id": api_scoped_id($cmp.icon)
    }
  }, null), api_static_part(3, null, api_dynamic_text($cmp.iconDescription))]) : null, !$cmp.externalIconSet ? api_element("svg", {
    className: api_normalize_class_name($cmp.classes),
    attrs: {
      "data-internal-icons": "",
      "viewBox": "0 0 52 52",
      "role": "img",
      "aria-label": $cmp.iconDescription,
      "aria-hidden": $cmp.ariaHidden
    },
    context: stc0,
    key: 2,
    svg: true
  }) : null];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-3g3p73eh84s";
tmpl.legacyStylesheetToken = "ax-icon_icon";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
